export function unescapeJsonString(jsonString: string): string {
    return jsonString.replaceAll('\"', '"');
}
